import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

const authorizedIssuersSlice = createSlice({
    name: 'authorizedIssuers',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default authorizedIssuersSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = authorizedIssuersSlice.actions;
export const selectFilters = (state: RootState) => state.authorizedIssuers.filters;
